import moment from 'moment';
import { httpClient } from '../../../../net/httpClient';
import UrlConfig from '../../../../net/UrlConfig';
import {
    RULE_REPORT_INPUT_CHANGE,
    START_LOAD_RULE_REPORT,
    LOAD_RULE_REPORT_SUCCESS,
    LOAD_RULE_REPORT_FAILURE,
    INIT_LOAD_RULE_REPORT_ACTION_STATUS,
    START_GENERATE_RULE_REPORT,
    GENERATE_RULE_REPORT_SUCCESS,
    GENERATE_RULE_REPORT_FAILURE,
    INIT_GENERATE_RULE_REPORT_ACTION_STATUS,
    OPEN_RESOLVE_RULE_REPORT_MODAL,
    CLOSE_RESOLVE_RULE_REPORT_MODAL,
    RESOLVE_RULE_REPORT_CHANGE_INPUT,
    START_UPDATE_RULE_REPORT,
    UPDATE_RULE_REPORT_SUCCESS,
    UPDATE_RULE_REPORT_FAILURE,
    INIT_UPDATE_RULE_REPORT_ACTION_STATUS,
    SELECT_RULE_REPORT,
    START_STAT_REPORT,
    STAT_REPORT_SUCCESS,
    STAT_REPORT_FAILURE,
    INIT_STAT_REPORT_ACTION_STATUS,
} from './ruleReportConstants';

export function selectRuleReport(selectedArray) {
    return { type: SELECT_RULE_REPORT, payload: selectedArray };
}

export function ruleReportInputChange({ name, value }) {

    return { type: RULE_REPORT_INPUT_CHANGE, payload: { name, value } };
}

function startLoadRuleReport() { return { type: START_LOAD_RULE_REPORT }; }
function loadRuleReportSuccess(resp) { return { type: LOAD_RULE_REPORT_SUCCESS, payload: resp }; }
function loadRuleReportFailure(err) { return { type: LOAD_RULE_REPORT_FAILURE, payload: err }; }

export function loadRuleReport(date, ruleCategory, fund) {
    const params = {};
    if (date) {
        params.date = moment.isMoment(date) ? date.format('YYYY-MM-DD') : date;
    }
    if (ruleCategory && ruleCategory !== 'All') {
        params.ruleCategory = ruleCategory;
    }
    if (fund && fund !== 'All') {
        params.fund = fund;
    }
    return dispatch => {
        dispatch(startLoadRuleReport());
        httpClient.get(UrlConfig.QUERY_RULE_REPORT, params)
            .then(resp => dispatch(loadRuleReportSuccess(resp)))
            .catch(err => dispatch(loadRuleReportFailure(err)));
    };
}

export function initLoadRuleReportActionStatus() { return { type: INIT_LOAD_RULE_REPORT_ACTION_STATUS }; }

function startGenerateRuleReport() { return { type: START_GENERATE_RULE_REPORT }; }
function generateRuleReportSuccess(resp) { return { type: GENERATE_RULE_REPORT_SUCCESS, payload: resp }; }
function generateRuleReportFailure(err) { return { type: GENERATE_RULE_REPORT_FAILURE, payload: err }; }

export function generateRuleReport(date, ruleCategory, fund) {
    let params = {};
    if (typeof date === 'object' && date !== null && !moment.isMoment(date)) {
        let d = date.date;
        if (d && moment.isMoment(d)) {
            d = d.format('YYYY-MM-DD');
        }
        params = { ...date, date: d };
    } else {
        let formattedDate = date;
        if (date && moment.isMoment(date)) {
            formattedDate = date.format('YYYY-MM-DD');
        }
        params = {
            date: formattedDate || '',
            ruleCategory: ruleCategory || '',
            fund: fund || '',
        };
    }
    return dispatch => {
        dispatch(startGenerateRuleReport());
        httpClient.get(UrlConfig.GENERATE_RULE_REPORT, params)
            .then(resp => dispatch(generateRuleReportSuccess(resp)))
            .catch(err => dispatch(generateRuleReportFailure(err)));
    };
}

export function initGenerateRuleReportActionStatus() { return { type: INIT_GENERATE_RULE_REPORT_ACTION_STATUS }; }

export function openResolveRuleReportModal(record) {
    return { type: OPEN_RESOLVE_RULE_REPORT_MODAL, payload: record };
}

export function closeResolveRuleReportModal() {
    return { type: CLOSE_RESOLVE_RULE_REPORT_MODAL };
}

export function resolveRuleReportChangeInput({ name, value }) {
    return { type: RESOLVE_RULE_REPORT_CHANGE_INPUT, payload: { name, value } };
}

function startUpdateRuleReport() { return { type: START_UPDATE_RULE_REPORT }; }
function updateRuleReportSuccess(resp) { return { type: UPDATE_RULE_REPORT_SUCCESS, payload: resp }; }
function updateRuleReportFailure(err) { return { type: UPDATE_RULE_REPORT_FAILURE, payload: err }; }

export function updateRuleReport(ruleReportVO) {
    return dispatch => {
        dispatch(startUpdateRuleReport());
        if (Array.isArray(ruleReportVO)) {
            const requests = ruleReportVO.map(item => httpClient.post(UrlConfig.UPDATED_RULE_REPORT, item));
            Promise.all(requests)
                .then(resp => dispatch(updateRuleReportSuccess(resp)))
                .catch(err => dispatch(updateRuleReportFailure(err)));
        } else {
            httpClient.post(UrlConfig.UPDATED_RULE_REPORT, ruleReportVO)
                .then(resp => dispatch(updateRuleReportSuccess(resp)))
                .catch(err => dispatch(updateRuleReportFailure(err)));
        }
    };
}

export function initUpdateRuleReportActionStatus() { return { type: INIT_UPDATE_RULE_REPORT_ACTION_STATUS }; }

function startStatReport() { return { type: START_STAT_REPORT }; }
function statReportSuccess(resp) { return { type: STAT_REPORT_SUCCESS, payload: resp }; }
function statReportFailure(err) { return { type: STAT_REPORT_FAILURE, payload: err }; }

export function generateStatReport(fromDate, toDate) {
    const params = {
        fromDate: moment.isMoment(fromDate) ? fromDate.format('YYYY-MM-DD') : fromDate,
        toDate: moment.isMoment(toDate) ? toDate.format('YYYY-MM-DD') : toDate,
    };
    return dispatch => {
        dispatch(startStatReport());
        httpClient.get(UrlConfig.STAT_RULE_REPORT, params)
            .then(resp => dispatch(statReportSuccess(resp)))
            .catch(err => dispatch(statReportFailure(err)));
    };
}

export function initStatReportActionStatus() { return { type: INIT_STAT_REPORT_ACTION_STATUS }; }
